// frontend/jtp-vue/src/i18n/index.ts
import { createI18n } from "vue-i18n"
import ConfigService from "@shared/helpers/configServices"

const fileNameToLocaleModuleDict = import.meta.glob<{ default: Record<string, string> }>("./locales/*.json", {
  eager: true,
})

const hostMessages: { [P: string]: Record<string, string> } = {}
Object.entries(fileNameToLocaleModuleDict)
  .map(([fileName, localeModule]) => {
    const fileNameParts = fileName.split("/")
    const fileNameWithoutPath = fileNameParts[fileNameParts.length - 1]
    const localeName = fileNameWithoutPath.split(".json")[0]

    return [localeName, localeModule.default] as const
  })
  .forEach((localeNameLocaleMessagesTuple) => {
    hostMessages[localeNameLocaleMessagesTuple[0]] = localeNameLocaleMessagesTuple[1]
  })

// Function to create i18n with merged messages
export async function createI18nWithRemote() {
  const mergedMessages = { ...hostMessages }
  const remoteApps = ConfigService.Current.remoteApps.split(",").map((app: string) => app.trim())
  try {
    if (remoteApps.includes("jtp-policy")) {
      const { remoteTranslations } = await import("jtp-policy/locales")
      // Merge remote translations
      Object.entries(remoteTranslations).forEach(([locale, remoteMessages]) => {
        if (
          mergedMessages[locale] &&
          typeof mergedMessages[locale] === "object" &&
          remoteMessages &&
          typeof remoteMessages === "object"
        ) {
          mergedMessages[locale] = { ...mergedMessages[locale], ...remoteMessages }
        } else {
          mergedMessages[locale] = remoteMessages as Record<string, string>
        }
      })
    }
  } catch (error) {
    console.warn("Remote translations not available, using host only:", error)
  }

  return createI18n({
    legacy: false,
    locale: "en-US",
    fallbackLocale: {
      "en-AU": ["en-US"],
      "en-GB": ["en-US"],
      default: ["en-US"],
    },
    messages: mergedMessages,
  })
}

// Default export for backward compatibility
export default createI18n({
  legacy: false,
  locale: "en-US",
  fallbackLocale: {
    "en-AU": ["en-US"],
    "en-GB": ["en-US"],
    default: ["en-US"],
  },
  messages: hostMessages,
})
